import { useParams } from 'react-router-dom';
export default function useCarleadHashParam() {
  const {
    carleadHash
  } = useParams();
  return carleadHash;
}